import { RootState } from '@/store/store';
import { PageTypes } from '@/store/types/pageTypes';
import { createSelector } from '@reduxjs/toolkit';
import { selectRating } from '@/store/selectors/ratingSelectors';

export const selectPage = (state: RootState): PageTypes => state.page;

export const selectPageTitle = createSelector(
	[selectPage],
	(pageState) => pageState.data.title
);

export const selectPageDescription = createSelector(
	[selectPage],
	(pageState) => pageState.data.description
);

export const selectPageCanonical = createSelector(
	[selectPage],
	(pageState) => pageState.data.canonical
);
